import { createSlice } from "@reduxjs/toolkit";
import { STATE_NAMES } from "./StateNames";

export enum ACTIVE_PROJECTS_PAGE {
    PER_PAGE = 'perPage',
    SORT_BY = 'sortBy',
}

const ActiveProjectsPageSlice = createSlice({
    name: STATE_NAMES.ACTIVE_PROJECTS_PAGE,
    initialState: {
        [ACTIVE_PROJECTS_PAGE.PER_PAGE]: null,
        [ACTIVE_PROJECTS_PAGE.SORT_BY]: null,
    },
    reducers: {
        setActiveProjectsPerPage: (state, action) => {
            state[ACTIVE_PROJECTS_PAGE.PER_PAGE] = action.payload;
        },
        setActiveProjectsSortBy: (state, action) => {
            state[ACTIVE_PROJECTS_PAGE.SORT_BY] = action.payload;
        },
    },
    selectors: {
        getActiveProjectsPerPage: state => state[ACTIVE_PROJECTS_PAGE.PER_PAGE],
        getActiveProjectsSortBy: state => state[ACTIVE_PROJECTS_PAGE.SORT_BY],
    }
})

export const {
    setActiveProjectsPerPage,
    setActiveProjectsSortBy
} = ActiveProjectsPageSlice.actions;
export const {
    getActiveProjectsPerPage,
    getActiveProjectsSortBy
} = ActiveProjectsPageSlice.selectors;

export default ActiveProjectsPageSlice.reducer;
